// extracted by mini-css-extract-plugin
export default {"span-checked":"MultiStep_span-checked__jYam9"};